import { useStaleStore } from '../stores/staleStore';
import './StaleBanner.css';

const UPSTREAM_LABEL: Record<string, string> = {
  stage1: 'Definition & Core Identity',
  stage1b: 'Fake Definitions',
};

interface StaleBannerProps {
  wordId: string;
  currentStage: string;
  onGenerate: () => void;
  onRegenerateAllStale?: () => void;
  generating: boolean;
}

export default function StaleBanner({ wordId, currentStage, onGenerate, onRegenerateAllStale, generating }: StaleBannerProps) {
  const { isStale, clearStaleStage, staleStages, getDownstream } = useStaleStore();
  const stale = isStale(currentStage);
  const downstream = getDownstream(currentStage);
  const hasStaleDownstream = downstream.some((s) => staleStages.includes(s));

  if (!stale && !hasStaleDownstream) return null;

  const sourceLabel = UPSTREAM_LABEL[currentStage] || currentStage;

  return (
    <div className="stale-banner-wrap">
      {stale && (
        <div className="stale-banner">
          <span className="stale-banner-text">
            This content was generated against a previous version of upstream content.
          </span>
          <div className="stale-banner-actions">
            <button
              className="stale-btn stale-btn-regen"
              onClick={onGenerate}
              disabled={generating}
            >
              {generating ? 'Regenerating...' : 'Regenerate'}
            </button>
            <button
              className="stale-btn"
              onClick={() => clearStaleStage(wordId, currentStage)}
            >
              Keep as-is
            </button>
          </div>
        </div>
      )}

      {hasStaleDownstream && !stale && (
        <div className="stale-banner stale-banner-source">
          <span className="stale-banner-text">
            You re-edited {sourceLabel}. {staleStages.length} downstream stage{staleStages.length !== 1 ? 's are' : ' is'} stale.
          </span>
          <div className="stale-banner-actions">
            <button
              className="stale-btn stale-btn-regen"
              onClick={onRegenerateAllStale}
              disabled={generating || !onRegenerateAllStale}
            >
              Regenerate all stale stages
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
